import { useEffect } from "react";

import api from "../../services/api";
import { useAuth } from "../../providers/auth";

//One Signal
window.OneSignal = window.OneSignal || [];
const oneSignal = window.OneSignal;
const oneSignalAppId = "b14e5378-9568-46a6-945b-f34fb8947f0f";
const oneSignalAllowedOrigin = "https://gvmdesk.grupoviamaquinas.com.br";

const OneSignal = props => {
  const { user } = useAuth();

  useEffect(() => {
    if (window.location.origin !== oneSignalAllowedOrigin || !oneSignalAppId) {
      return;
    }

    oneSignal.push(() => {
      oneSignal.init(
        {
          appId: oneSignalAppId,
          promptOptions: {
            slidedown: {
              enabled: true,
              actionMessage: "Você gostaria de receber notificações de novas mensagens no App?",
              acceptButtonText: "SIM",
              cancelButtonText: "CANCELAR"
            }
          },
          welcomeNotification: {
            "title": "GVMDesk",
            "message": "Assinatura feita com sucesso.",
          }
        }
      );

      oneSignal.on("subscriptionChange", function (isSubscribed) {
        console.log("The user's subscription state is now:", isSubscribed);
      });

      oneSignal.getUserId().then(function (userId) {
        sendPlayerId(userId);
      });

    });
  }, []);

  async function sendPlayerId(playerId) {
    try {
      const response = await api.post("/admin/notification", { "player_id": playerId }, { headers: { "Authorization": "Bearer " + user.token } });

    } catch (e) {
      console.log(e);
    }
  }

  return props.children;
}

export default OneSignal;
